import documentClass from './utility/document-class.js';

import toggleClass from './utility/toggle-class.js';
import toggleClassGroup from './utility/toggle-class-group.js';

import showDatePicker from './utility/show-date-picker.js';
import dateMinMax from './utility/date-min-max.js';
import dateControl from './utility/date-control.js';

import formReset from './utility/form-reset.js';
import checkAll from './utility/check-all.js';
import toggleFormControl from './utility/toggle-form-control.js';
import inputNumeric from './utility/input-numeric.js';
import inputFileOption from './utility/input-file-option.js';
import attachFileList from './utility/attach-file-list.js';

import controlDialog from './component/control-dialog.js';
import loadingLayer from './component/loading-layer.js';

// import documentTitle from './utility/document-title.js';
import addAriaAttribute from './utility/add-aria-attribute.js';

const _beforeDOMContentLoaded = {
 documentClass,
};

const _afterDOMContentLoaded = {
 toggleClass,
 toggleClassGroup,

 showDatePicker,
 dateMinMax,
 dateControl,

 formReset,
 checkAll,
 toggleFormControl,
 inputNumeric,
 inputFileOption,
 attachFileList,

 controlDialog,
 loadingLayer,

 // documentTitle,
 addAriaAttribute,
};

window.FEUI = {
 ..._beforeDOMContentLoaded,
 ..._afterDOMContentLoaded,
 ...(window.FEUI || {}),
};

FEUI.PATH = FEUI.PATH || `../../`;

const _skipBeforeFunc = [];
const _skipAfterFunc = [];

for (let func in _beforeDOMContentLoaded) {
 if (_skipBeforeFunc.includes(func)) continue;
 if (typeof FEUI[func] === `function`) FEUI[func]();
}

document.addEventListener(`DOMContentLoaded`, () => {
 const initNavigation = () => {
 const currentDepth1 = document.querySelector(
 `.nav > ul > li:has(.current) > a`,
 );
 const currentDepth2 = document.querySelector(
 `.nav-depth-2 li:has(.nav-depth-3 .current) > a`,
 );
 const releaseHoverLock = () => {
 document
 .querySelector(`.nav .hover-lock`)
 ?.classList.remove(`hover-lock`);
 };

 document
 .querySelectorAll(`.nav-depth-2 > li:has(.depth-wrap) > a`)
 ?.forEach((el) => {
 el.setAttribute(`data-toggle-content`, ``);
 });

 if (location.hash) {
 const targetElement = document.querySelector(location.hash);

 if (targetElement) {
 targetElement.scrollIntoView({
 // behavior: `smooth`,
 block: `start`,
 });
 }
 }

 if (!currentDepth1) return;

 currentDepth1.classList.add(`hover-lock`);
 currentDepth1.addEventListener(`pointerleave`, releaseHoverLock);

 document
 .querySelectorAll(`.content, .depth-wrap:has(.current)`)
 ?.forEach((el) => {
 el.addEventListener(`pointerenter`, releaseHoverLock);
 });

 currentDepth2?.classList.add(`active`);
 };
 initNavigation();

 for (let func in _afterDOMContentLoaded) {
 if (_skipAfterFunc.includes(func)) continue;
 if (typeof FEUI[func] === `function`) FEUI[func]();
 }
});
